export function nodes<T>({ edges }: { edges: [{ node: T }] }) {
  return edges.map(edge => edge.node);
}
